import 'slick-carousel';

function pageSliderInstance(carouselEl) {
  const $sliderEl = $(carouselEl);
  const pageSlider = $('.related-links-slider__articles', $sliderEl);
  const totalSlides = $('.related-links-slider__article', $sliderEl).length;

  pageSlider.on('init', () => {
    pageSlider.find('.slick-slide').each(function () {
      const index = $(this).find('[data-slide-index]').attr('data-slide-index');
      $(this).attr('aria-label', `slide ${index} of ${totalSlides}`);
      $(this).attr('aria-roledescription', 'slide');
    });
  });

  pageSlider.slick({
    lazyLoad: 'ondemand',
    arrows: true,
    infinite: true,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    prevArrow:
      '<button class="c-btn-circle c-btn-circle--secondary c-btn-circle--lg slick-arrow slick-prev" data-carousel="previous"><i class="c-icon icon-chevron-left" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 16" id="chevron-left"><path d="M9.243 2.343 7.828.93.758 8l7.07 7.071 1.415-1.414L3.586 8l5.657-5.657z" fill="currentColor"></path></svg></i><span class="u-visuallyhidden">Previous slide</span></button>',
    nextArrow:
      '<button class="c-btn-circle c-btn-circle--secondary c-btn-circle--lg slick-arrow slick-next" data-carousel="next"><i class="c-icon icon-chevron-right" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 16" id="chevron-right"><path d="M.586 2.343 2 .93 9.071 8 2 15.071.586 13.657 6.243 8 .586 2.343z" fill="currentColor"></path></svg></i><span class="u-visuallyhidden">Next slide</span></button>',
  });

  let currentSlide = pageSlider.slick('slickCurrentSlide');

  pageSlider.on('afterChange', () => {
    currentSlide = pageSlider.slick('slickCurrentSlide');

    $('.carousel-gallery__current', $sliderEl)
      .empty()
      .append(currentSlide + 1);
  });

  $('.carousel-gallery__current', $sliderEl).html(currentSlide + 1);
  $('.carousel-gallery__total', $sliderEl).html(totalSlides);
}

function pageGalleryCarousel() {
  const $galleries = $('[data-page-gallery]');

  $galleries.each((i, gallery) => {
    pageSliderInstance(gallery);
  });
}

export function init() {
  pageGalleryCarousel();
}
